// src/pages/components/ToolbarHeader.jsx
import React from "react";
import { toast } from "react-toastify";
import "./css/ToolbarHeader.css";

// Reusable GTA game tabs (exported)
export const GTA_GAME_TABS = [
  { key: "all", label: "All" },
  { key: "gta-6", label: "GTA VI" },
  { key: "gta-5", label: "GTA V" },
  { key: "gta-4", label: "GTA IV" },
  { key: "gta-sa", label: "San Andreas" },
  { key: "gta-vc", label: "Vice City" },
  { key: "gta-3", label: "GTA III" },
];

// Convenience: <select> options derived from tabs (exported)
export const GTA_GAME_OPTIONS = GTA_GAME_TABS.map(({ key, label }) => ({
  value: key,
  label,
}));

export default function ToolbarHeader({
  title,
  search,
  setSearch,
  placeholder,
  onAddMission,
  onAddCharacter,
  addLabel = "＋ Add Mission",
  addCharacterLabel = "＋ Add Character",
  user,
  authUser,
  children,

  // Game filter props
  game = "all",
  setGame,
  gameOptions,          // if not provided and showGtaFilter is true, will default to GTA_GAME_OPTIONS
  showGtaFilter = false // NEW: quickly render a GTA game dropdown without wiring options each time
}) {
  const isLoggedIn = !!(authUser?.uid || user?.uid || user);
  const guarded = (fn) => {
    if (!fn) return;
    if (!isLoggedIn) {
      toast.error("Please log in to continue.", {
        theme: document.documentElement.dataset.theme || "light",
      });
      return;
    }
    fn();
  };

  // Decide which options to use when showing the GTA filter
  const effectiveGameOptions =
    showGtaFilter ? (gameOptions && gameOptions.length ? gameOptions : GTA_GAME_OPTIONS) : [];

  return (
    <div className="toolbar toolbar-2row">
      {/* TOP ROW: title + filter text/select */}
      <div className="toolbar-row toolbar-row-top">
        <div className="toolbar-title">
          {children || <h2 className="forum-header">{title}</h2>}
        </div>

        {/* Filter text + select on the top row */}
        <div className="toolbar-filter-top">
          {/* Generic filter (when consumer provides options manually) */}
          {!showGtaFilter && setGame && Array.isArray(gameOptions) && gameOptions.length > 0 && (
            <label className="toolbar-filter-label">
              Filter:
              <select
                className="toolbar-select"
                value={game}
                onChange={(e) => setGame(e.target.value)}
                aria-label="Filter by game"
                title="Filter by game"
              >
                {gameOptions.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </label>
          )}

          {/* Quick GTA filter (auto-uses GTA_GAME_OPTIONS unless you override via gameOptions) */}
          {showGtaFilter && setGame && (
            <label className="toolbar-filter-label">
              Filter:
              <select
                className="toolbar-select"
                value={game}
                onChange={(e) => setGame(e.target.value)}
                aria-label="Filter by game"
                title="Filter by game"
              >
                {effectiveGameOptions.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </label>
          )}
        </div>
      </div>

      {/* BOTTOM ROW: search input + buttons */}
      <div className="toolbar-row toolbar-row-bottom">
        <div className="toolbar-filters">
          {/* Search */}
          <input
            className="toolbar-input"
            type="text"
            placeholder={placeholder}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            aria-label={placeholder}
          />

          {onAddMission && (
            <button className="toolbar-btn" onClick={() => guarded(onAddMission)}>
              {addLabel}
            </button>
          )}

          {onAddCharacter && (
            <button className="toolbar-btn" onClick={() => guarded(onAddCharacter)}>
              {addCharacterLabel}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
